import React from 'react';
export const LoadingIndicator = (props) => (React.createElement("h2", { className: props.className, "data-pw": "loadingIndicator" }, "Ladataan"));
